import {
  apiRequest,
  skp3kList,
  skp3kActive,
  skp3kInactive,
} from "../../../../../services/adapters/kepegawaian/skp3kService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      skp3kList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      skp3kInactive,
      {
        body: query,
      },
      true
    );
  };

  fetchActive = async (query) => {
    return await apiRequest(
      "post",
      skp3kActive,
      {
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
